/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPaymentsIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-payments"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M2.7 20.65Q1.57 20.65 0.81 19.89Q0.05 19.13 0.05 18L0.05 7.53Q0.05 6.97 0.44 6.59Q0.82 6.2 1.38 6.2Q1.93 6.2 2.31 6.59Q2.7 6.97 2.7 7.53L2.7 18Q2.7 18 2.7 18Q2.7 18 2.7 18L19.52 18Q20.07 18 20.46 18.39Q20.85 18.77 20.85 19.32Q20.85 19.88 20.46 20.26Q20.07 20.65 19.52 20.65ZM6.8 16.6Q5.67 16.6 4.91 15.84Q4.15 15.07 4.15 13.95L4.15 5.8Q4.15 4.67 4.91 3.91Q5.67 3.15 6.8 3.15L21.3 3.15Q22.43 3.15 23.19 3.91Q23.95 4.67 23.95 5.8L23.95 13.95Q23.95 15.07 23.19 15.84Q22.43 16.6 21.3 16.6ZM9.1 13.95Q9.1 13 8.43 12.32Q7.75 11.65 6.8 11.65L6.8 13.95Q6.8 13.95 6.8 13.95Q6.8 13.95 6.8 13.95ZM19 13.95L21.3 13.95Q21.3 13.95 21.3 13.95Q21.3 13.95 21.3 13.95L21.3 11.65Q20.35 11.65 19.68 12.32Q19 13 19 13.95ZM14.05 12.88Q15.3 12.88 16.16 11.99Q17.02 11.1 17.02 9.85Q17.02 8.6 16.16 7.74Q15.3 6.88 14.05 6.88Q12.8 6.88 11.91 7.74Q11.03 8.6 11.03 9.85Q11.03 11.13 11.9 12Q12.78 12.88 14.05 12.88ZM6.8 8.1Q7.75 8.1 8.43 7.42Q9.1 6.75 9.1 5.8L6.8 5.8Q6.8 5.8 6.8 5.8Q6.8 5.8 6.8 5.8ZM21.3 8.1L21.3 5.8Q21.3 5.8 21.3 5.8Q21.3 5.8 21.3 5.8L19 5.8Q19 6.75 19.68 7.42Q20.35 8.1 21.3 8.1Z" fill={color} />
    </svg>
  );
}
